import { ElementRef } from '@angular/core';

/** every way a screen can tell a hint bubble what to point at */
export interface HintTargetInputs {
  /** a selector looked up anywhere in the page; wins over `target` */
  globalTarget?: HTMLElement | string;
  /** a selector for the nearest enclosing element, or the element itself */
  target?: HTMLElement | ElementRef<HTMLElement> | string;
  /** a selector applied inside whatever `target` resolved to */
  targetChild?: string;
}

/**
 * Turn a hint bubble's inputs into the one element it points at, or null when there is none.
 *
 * `contentElement` is the bubble's own content, still in its original place in the page, so a
 * `target` selector finds the nearest enclosing match. A `targetChild` applies only to `target`,
 * never to `globalTarget`.
 */
export function resolveHintTarget(contentElement: HTMLElement, inputs: HintTargetInputs): HTMLElement | null {
  if (inputs.globalTarget) {
    return document.querySelector(inputs.globalTarget as string) as HTMLElement;
  }

  let target: HTMLElement | null;
  if (typeof inputs.target == 'string') {
    target = contentElement.closest(inputs.target) as HTMLElement;
  } else if (inputs.target instanceof ElementRef) {
    target = inputs.target.nativeElement;
  } else {
    target = inputs.target ?? null;
  }

  if (inputs.targetChild && target) {
    target = target.querySelector(inputs.targetChild) as HTMLElement;
  }
  return target;
}
